<script>
    import { isActive, url } from "@sveltech/routify"
    import { t } from "totalinvoice-frontend-core"
    import { canActivatePage, permissions } from "../common/Guard"

    export let node

    $: canActivate = canActivatePage(node, $permissions)
</script>

{#if node && node.meta["showInNavigation"] && canActivate}
    {#if node.meta["flat"]}
        {#each node.children as child}
            <svelte:self node={child} />
        {/each}
    {:else}
        {#if node.children && node.children.length > 0}
            <div class="navbar-item has-dropdown is-hoverable">
                <a href={$url(node.path)} class="navbar-link">
                    {$t(node.title)}
                </a>
                <div class="navbar-dropdown">
                    {#each node.children as child}
                        <svelte:self node={child} />
                    {/each}
                </div>
            </div>
        {:else}
            <a href={$url(node.path)} class="navbar-item" class:is-active={$isActive(node.path)}>
                {$t(node.title)}
            </a>
        {/if}
    {/if}
{/if}
